import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const faqs = [
  {
    q: 'Where is the best car wrap installation near me in Sacramento, CA?',
    a: 'WrapAlot Specialty Filmz at 1817 Del Paso Blvd, Sacramento, CA 95815 is a top-rated car wrap installation shop serving Sacramento and surrounding areas including Elk Grove, Roseville, Folsom and Citrus Heights. Call 916-336-7865 for a free quote.'
  },
  {
    q: 'How much does a car wrap cost in Sacramento?',
    a: 'Full vehicle color-change wraps in Sacramento typically range from $2,500 to $5,000+ depending on the vehicle size, vinyl brand (e.g., 3M, Avery, KPMF) and finish (gloss, matte, satin, chrome). Partial wraps and commercial fleet graphics start lower. We offer free, no-obligation quotes.'
  },
  {
    q: 'How long does a car wrap installation take?',
    a: 'A full color-change vehicle wrap typically takes 3 to 5 business days from drop-off to pickup. Partial wraps, decals and commercial fleet graphics are usually completed in 1 to 2 days.'
  },
  {
    q: 'How long do vehicle wraps last?',
    a: 'A professionally installed premium vehicle wrap lasts 5 to 7 years on average, and is backed by our 5-year warranty when properly maintained and stored out of constant direct sunlight.'
  },
  {
    q: 'Do car wraps damage the original paint?',
    a: 'No. When installed by certified professionals on factory paint in good condition, vinyl wraps actually protect the original paint from UV rays, minor scratches and road debris, and they can be safely removed without damage.'
  },
  {
    q: 'Do you offer paint protection film (PPF) in Sacramento?',
    a: 'Yes. We install self-healing clear paint protection film (PPF) on full vehicles, partial fronts, and high-impact areas like the hood, fenders, mirrors and bumpers throughout the Sacramento area.'
  },
  {
    q: 'Do you offer free quotes for vehicle wraps?',
    a: 'Yes. We offer free design consultations and no-obligation written quotes for all car wrap installations in Sacramento, CA. Call 916-336-7865 or fill out the contact form to get started.'
  }
];

const FAQItem = ({ q, a, isOpen, onToggle, idx }) => (
  <div className="bg-slate-800/50 rounded-xl overflow-hidden hover:bg-slate-800/70 transition-colors">
    <button
      data-testid={`faq-toggle-${idx}`}
      onClick={onToggle}
      aria-expanded={isOpen}
      aria-controls={`faq-panel-${idx}`}
      className="w-full flex items-center justify-between gap-4 p-6 text-left"
    >
      <h3 className="text-lg md:text-xl font-semibold text-white">{q}</h3>
      <ChevronDown
        className={`w-5 h-5 text-cyan-400 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}
      />
    </button>
    <div
      id={`faq-panel-${idx}`}
      className={`grid transition-all duration-300 ease-in-out ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`}
    >
      <div className="overflow-hidden">
        <p className="px-6 pb-6 text-gray-400 leading-relaxed">{a}</p>
      </div>
    </div>
  </div>
);

const FAQ = () => {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section id="faq" className="bg-slate-900 py-20 md:py-28" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Car Wrap Installation FAQs <span className="text-cyan-400">— Sacramento, CA</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Quick answers to the most common questions about car wraps, paint protection film and window tint in the Sacramento area.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((item, idx) => (
            <FAQItem
              key={idx}
              idx={idx}
              q={item.q}
              a={item.a}
              isOpen={openIdx === idx}
              onToggle={() => setOpenIdx(openIdx === idx ? -1 : idx)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
